import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import { Outlet, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import { Box } from "@mui/material";

const Dashboard = () => {
  const user = useSelector((state) => state.user.user)
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDemographicData = async () => {
      if(user.userRole.includes("USER")){
        try {
          const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/demographic-data?username=${user.username}`)
          if(res.data && res.data.firstName === null){
            navigate('/profile')
          }
          console.log(res.data)
        } catch (error) {
          console.log(error)
        }
      }
    }

    fetchDemographicData();
  }, [])

  useEffect(() => {
    if(!user || !JSON.parse(localStorage.getItem('user'))){
      navigate('/')
    }

    if(user.userRole.includes("ADMIN")){
      navigate("/admin-dashboard")
    }
  }, [])

  return (
    <Box sx={{ position: "relative", display: {xs: 'block', sm: 'none !important'} }}>
      <Outlet />
      <Navbar />
    </Box>
  );
};

export default Dashboard;
